/*
 * style: 
 *   'full' : Display current date and time
 *   'date' : Only display current date
 *   'time' : Only display current time
 */
(function () {
  module.exports = function (style, delimiterForDate, delimiterForTime) {
    var date, day, hours, minutes, month, seconds, year;

    if (style == null) {
      style = 'full';
    }

    if (delimiterForDate == null) {
      delimiterForDate = '-';
    }

    if (delimiterForTime == null) {
      delimiterForTime = ':';
    }

    date = new Date();
    year = date.getFullYear();
    month = date.getMonth() + 1;
    day = date.getDate();
    hours = date.getHours();
    minutes = date.getMinutes();
    seconds = date.getSeconds();

    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }

    if (hours < 10) {
      hours = '0' + hours;
    }

    if (minutes < 10) {
      minutes = '0' + minutes;
    }

    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    if (style === 'full') {
      return year + delimiterForDate + month + delimiterForDate + day + " " + hours + delimiterForTime + minutes + delimiterForTime + seconds;
    }

    if (style === 'date') {
      return year + delimiterForDate + month + delimiterForDate + day;
    }

    if (style === 'time') {
      return hours + delimiterForTime + minutes + delimiterForTime + seconds;
    }
  };
}).call(this);